
const getDefaultState = () => {
  return {
    sort: [],
    group: [],
  }
}

const state = getDefaultState()

const getters = {
  getSort: state => state.sort,
  getGroup: state => state.group,
}

const mutations = {
  setSort (state, sort) {
    state.sort = sort
  },
  setGroup (state, group) {
    state.group = group
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  resetCartState ({ commit }) {
    commit('resetState')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
